const name = 'Admin';

export const MANAGE_ORG_INITIALISE = `[${name}] Initialise Manage Organisation`;
export const MANAGE_ORG_DESTROY = `[${name}] Destroy Manage Organisation`;
export const LOAD_ORGANISATIONS = `[${name}] Load Organisations`;
export const LOAD_ORGANISATIONS_DONE = `[${name}] Load Organisations Done`;
export const ORGANISATION_STATE_UPDATE_REQUEST = `[${name}] Organisation State Update Request`;
export const ORGANISATION_STATE_UPDATE_SUCCESS = `[${name}] Organisation State Update Success`;
export const ORGANISATION_STATE_UPDATE_FAILED = `[${name}] Organisation State Update Failed`;
export const MEMBER_STATE_UPDATE_REQUEST = `[${name}] Member State Update Request`;
export const MEMBER_STATE_UPDATE_SUCCESS = `[${name}] Member State Update Success`;
export const MEMBER_STATE_UPDATE_FAILED = `[${name}] Member State Update Failed`;